// src/hooks/useTranslation.js
import { useContext } from 'react';
import translations from './translations';
import { useLanguage } from './LanguageContext';

const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key, ...args) => {
    const translation = translations[language][key] || key;
    if (args.length === 0) return translation;
    return translation.replace(/\{(\d+)\}/g, (match, number) =>
      typeof args[number] !== 'undefined' ? args[number] : match
    );
  };

  return { t, language };
};


export default useTranslation;